import { TenantPackageConfig } from '~/tenants/common/registry';
import { MlmOrderContext, MlmOrderType } from '~/tenants/mlm/model/MlmOrder';
import MlmPhotosConfig from '~/tenants/mlm/performable/photos/MlmPhotosConfig';

const MlmFundamentalsPackageConfig: TenantPackageConfig = {
  id: 'photos',
  name: 'The Fundamentals',
  description: '',
  performables: [MlmPhotosConfig],
  eligible: (context) => (context as MlmOrderContext).metadata.type === MlmOrderType.RESIDENTIAL,
};

export default MlmFundamentalsPackageConfig;
